import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const TABS = [
    { value: 'USER', label: 'USER' },
    { value: 'COLLABORATOR', label: 'COLLABORATOR' },
];

const getEmptyRow = (role) => ({
    id: null,
    role,
    minUserOnline: '',
    maxUserOnline: '',
    minBotOnline: '',
    maxBotOnline: '',
    isActive: true,
});

export default class BOTLiveRoomManagerPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'USER',
            listByRole: {
                USER: [],
                COLLABORATOR: [],
            },
            conditionForm: {
                minRealUsers: '',
                minQueueSongs: '',
                minOnlineMinutes: '',
                maxOnlineMinutes: '',
            },
            loadingByRole: { USER: true, COLLABORATOR: true },
            savingId: null,
            deletingId: null,
            bulkDeactivating: false,
            bulkActivating: false,
            creatingDefaultCondition: false,
            savingCondition: false,
            loadingCondition: false,
            conditionValidationErrors: [],
            validationErrors: {},
        };
    }

    componentDidMount() {
        TABS.forEach((tab) => this.loadRoleSettings(tab.value));
        this.loadConditionSetting();
    }

    loadRoleSettings = (role) => {
        this.setState((prev) => ({
            loadingByRole: { ...prev.loadingByRole, [role]: true }
        }));
        axios.post(global.config.apiDomain + '/bot/web/bot-live-room/get-role-settings', {
            role
        })
            .then((res) => {
                const settings = (res.data && res.data.settings) ? res.data.settings : [];
                const list = Array.isArray(settings)
                    ? settings.map((s) => ({
                        id: s.id,
                        role: s.role || role,
                        minUserOnline: s.minUserOnline ?? '',
                        maxUserOnline: s.maxUserOnline ?? '',
                        minBotOnline: s.minBotOnline ?? '',
                        maxBotOnline: s.maxBotOnline ?? '',
                        isActive: s.isActive !== false,
                    }))
                    : [];
                this.setState((prev) => ({
                    listByRole: { ...prev.listByRole, [role]: list },
                    loadingByRole: { ...prev.loadingByRole, [role]: false }
                }));
            })
            .catch(() => {
                this.setState((prev) => ({
                    listByRole: { ...prev.listByRole, [role]: [] },
                    loadingByRole: { ...prev.loadingByRole, [role]: false }
                }));
                toast.error(`Không tải được cài đặt cho ${role}.`);
            });
    };

    handleAddRow = () => {
        const { activeTab, listByRole } = this.state;
        const newRow = getEmptyRow(activeTab);
        this.setState({
            listByRole: {
                ...listByRole,
                [activeTab]: [...listByRole[activeTab], newRow]
            }
        });
    };

    handleChangeRow = (index, field, value) => {
        const { activeTab, listByRole, validationErrors } = this.state;
        const list = [...listByRole[activeTab]];
        list[index] = {
            ...list[index],
            [field]: field === 'isActive' ? !!value : value
        };
        const newErrors = { ...validationErrors };
        if (newErrors[index]) {
            newErrors[index] = newErrors[index].filter((f) => f !== field);
            if (newErrors[index].length === 0) delete newErrors[index];
        }
        this.setState({
            listByRole: { ...listByRole, [activeTab]: list },
            validationErrors: newErrors
        });
    };

    rangesOverlap = (a1, b1, a2, b2) => {
        return !(b1 < a2 || b2 < a1);
    };

    isFieldEmpty = (val) => val === '' || val === null || val === undefined;

    validateConditionForm = () => {
        const { conditionForm } = this.state;
        const invalidFields = [];

        if (this.isFieldEmpty(conditionForm.minRealUsers)) invalidFields.push('minRealUsers');
        if (this.isFieldEmpty(conditionForm.minQueueSongs)) invalidFields.push('minQueueSongs');
        if (this.isFieldEmpty(conditionForm.minOnlineMinutes)) invalidFields.push('minOnlineMinutes');
        if (this.isFieldEmpty(conditionForm.maxOnlineMinutes)) invalidFields.push('maxOnlineMinutes');

        if (invalidFields.length > 0) {
            toast.warning('Vui lòng nhập đầy đủ các trường điều kiện.');
            return { valid: false, invalidFields };
        }

        const minRealUsers = Number(conditionForm.minRealUsers);
        const minQueueSongs = Number(conditionForm.minQueueSongs);
        const minOnlineMinutes = Number(conditionForm.minOnlineMinutes);
        const maxOnlineMinutes = Number(conditionForm.maxOnlineMinutes);

        if ([minRealUsers, minQueueSongs, minOnlineMinutes, maxOnlineMinutes].some((v) => Number.isNaN(v))) {
            toast.warning('Vui lòng nhập số hợp lệ cho điều kiện.');
            return {
                valid: false,
                invalidFields: ['minRealUsers', 'minQueueSongs', 'minOnlineMinutes', 'maxOnlineMinutes']
            };
        }

        if (minRealUsers < 0 || minQueueSongs < 0 || minOnlineMinutes < 0 || maxOnlineMinutes < 0) {
            toast.warning('Các giá trị điều kiện không được âm.');
            return { valid: false, invalidFields: ['minRealUsers', 'minQueueSongs', 'minOnlineMinutes', 'maxOnlineMinutes'] };
        }

        if (minOnlineMinutes > maxOnlineMinutes) {
            toast.warning('Online phút tối thiểu không được lớn hơn tối đa.');
            return { valid: false, invalidFields: ['minOnlineMinutes', 'maxOnlineMinutes'] };
        }

        return { valid: true };
    };

    handleChangeConditionField = (field, value) => {
        const { conditionForm, conditionValidationErrors } = this.state;
        this.setState({
            conditionForm: {
                ...conditionForm,
                [field]: value
            },
            conditionValidationErrors: conditionValidationErrors.filter((f) => f !== field)
        });
    };

    handleCreateDefaultCondition = () => {
        const { creatingDefaultCondition } = this.state;
        if (creatingDefaultCondition) return;

        this.setState({ creatingDefaultCondition: true });
        axios.post(global.config.apiDomain + '/bot/web/bot-live-room/create-default-condition')
            .then(() => {
                toast.success('Tạo điều kiện mặc định thành công.');
                this.loadConditionSetting();
            })
            .catch(() => {
                toast.error('Tạo điều kiện mặc định thất bại.');
            })
            .finally(() => {
                this.setState({ creatingDefaultCondition: false });
            });
    };

    handleUpdateCondition = () => {
        const { savingCondition, conditionForm } = this.state;
        if (savingCondition) return;

        const validateResult = this.validateConditionForm();
        if (!validateResult.valid) {
            this.setState({ conditionValidationErrors: validateResult.invalidFields || [] });
            return;
        }

        this.setState({ savingCondition: true, conditionValidationErrors: [] });
        axios.post(global.config.apiDomain + '/bot/web/bot-live-room/update-condition', {
            minRealUsers: Number(conditionForm.minRealUsers),
            minQueueSongs: Number(conditionForm.minQueueSongs),
            minOnlineMinutes: Number(conditionForm.minOnlineMinutes),
            maxOnlineMinutes: Number(conditionForm.maxOnlineMinutes),
        })
            .then(() => {
                toast.success('Cập nhật điều kiện thành công.');
                this.loadConditionSetting();
            })
            .catch(() => {
                toast.error('Cập nhật điều kiện thất bại.');
            })
            .finally(() => {
                this.setState({ savingCondition: false });
            });
    };

    loadConditionSetting = () => {
        this.setState({ loadingCondition: true });
        axios.post(global.config.apiDomain + '/bot/web/bot-live-room/get-condition')
            .then((res) => {
                const condition = res.data || {};
                this.setState({
                    conditionForm: {
                        minRealUsers: condition.minRealUsers ?? '',
                        minQueueSongs: condition.minQueueSongs ?? '',
                        minOnlineMinutes: condition.minOnlineMinutes ?? '',
                        maxOnlineMinutes: condition.maxOnlineMinutes ?? '',
                    },
                    loadingCondition: false,
                    conditionValidationErrors: []
                });
            })
            .catch(() => {
                this.setState({ loadingCondition: false });
                toast.error('Không tải được điều kiện mặc định.');
            });
    };

    validateRow = (row, list, currentIndex) => {
        const invalidFields = [];
        if (this.isFieldEmpty(row.minUserOnline)) invalidFields.push('minUserOnline');
        if (this.isFieldEmpty(row.maxUserOnline)) invalidFields.push('maxUserOnline');
        if (this.isFieldEmpty(row.minBotOnline)) invalidFields.push('minBotOnline');
        if (this.isFieldEmpty(row.maxBotOnline)) invalidFields.push('maxBotOnline');
        if (invalidFields.length > 0) {
            toast.warning('Vui lòng nhập đầy đủ min/max User và min/max BOT.');
            return { valid: false, invalidFields };
        }
        const minU = Number(row.minUserOnline);
        const maxU = Number(row.maxUserOnline);
        const minB = Number(row.minBotOnline);
        const maxB = Number(row.maxBotOnline);
        if (isNaN(minU) || isNaN(maxU) || isNaN(minB) || isNaN(maxB)) {
            toast.warning('Vui lòng nhập số hợp lệ.');
            return { valid: false, invalidFields: ['minUserOnline', 'maxUserOnline', 'minBotOnline', 'maxBotOnline'] };
        }
        if (minU < 0 || maxU < 0) {
            toast.warning('Số user online không được âm.');
            return { valid: false, invalidFields: minU < 0 ? ['minUserOnline'] : ['maxUserOnline'] };
        }
        if (minU > maxU) {
            toast.warning('User tối thiểu không được lớn hơn tối đa.');
            return { valid: false, invalidFields: ['minUserOnline', 'maxUserOnline'] };
        }
        if (minB < 0 || maxB < 0) {
            toast.warning('Số BOT online không được âm.');
            return { valid: false, invalidFields: minB < 0 ? ['minBotOnline'] : ['maxBotOnline'] };
        }
        if (minB > maxB) {
            toast.warning('BOT tối thiểu không được lớn hơn tối đa.');
            return { valid: false, invalidFields: ['minBotOnline', 'maxBotOnline'] };
        }
        if (list && list.length > 0) {
            for (let i = 0; i < list.length; i += 1) {
                if (i === currentIndex) continue;
                const other = list[i];
                const oMinU = Number(other.minUserOnline);
                const oMaxU = Number(other.maxUserOnline);
                const oMinB = Number(other.minBotOnline);
                const oMaxB = Number(other.maxBotOnline);
                if (isNaN(oMinU) || isNaN(oMaxU) || isNaN(oMinB) || isNaN(oMaxB)) continue;
                if (this.rangesOverlap(minU, maxU, oMinU, oMaxU)) {
                    toast.warning(`Khoảng User [${minU}-${maxU}] chồng chéo với khoảng [${oMinU}-${oMaxU}] ở hàng khác.`);
                    return { valid: false, invalidFields: ['minUserOnline', 'maxUserOnline'] };
                }
            }
        }
        return { valid: true };
    };

    handleSaveNew = (index) => {
        const { activeTab, listByRole, validationErrors } = this.state;
        const list = listByRole[activeTab];
        const row = list[index];
        const result = this.validateRow(row, list, index);
        if (!result.valid) {
            this.setState({ validationErrors: { ...validationErrors, [index]: result.invalidFields || [] } });
            return;
        }
        this.setState({ validationErrors: {} });
        const payload = {
            role: activeTab,
            minUserOnline: Number(row.minUserOnline),
            maxUserOnline: Number(row.maxUserOnline),
            minBotOnline: Number(row.minBotOnline),
            maxBotOnline: Number(row.maxBotOnline),
            isActive: row.isActive,
        };
        this.setState({ savingId: `new-${index}` });
        axios.post(global.config.apiDomain + '/bot/web/bot-live-room/create', payload)
            .then(() => {
                this.setState({ savingId: null });
                toast.success('Tạo thành công.');
                this.loadRoleSettings(activeTab);
            })
            .catch(() => {
                this.setState({ savingId: null });
                toast.error('Tạo thất bại.');
            });
    };

    handleUpdate = (index) => {
        const { activeTab, listByRole, validationErrors } = this.state;
        const list = listByRole[activeTab];
        const row = list[index];
        const result = this.validateRow(row, list, index);
        if (!result.valid) {
            this.setState({ validationErrors: { ...validationErrors, [index]: result.invalidFields || [] } });
            return;
        }
        this.setState({ validationErrors: {} });
        if (!row.id) {
            toast.warning('Hàng này chưa lưu. Hãy bấm Lưu.');
            return;
        }
        this.setState({ savingId: row.id });
        const payload = {
            id: row.id,
            role: row.role,
            minUserOnline: Number(row.minUserOnline),
            maxUserOnline: Number(row.maxUserOnline),
            minBotOnline: Number(row.minBotOnline),
            maxBotOnline: Number(row.maxBotOnline),
            isActive: row.isActive,
        };
        axios.post(global.config.apiDomain + '/bot/web/bot-live-room/update', payload)
            .then(() => {
                this.setState({ savingId: null });
                toast.success('Cập nhật thành công.');
                this.loadRoleSettings(activeTab);
            })
            .catch(() => {
                this.setState({ savingId: null });
                toast.error('Cập nhật thất bại.');
            });
    };

    handleDelete = (index) => {
        const { activeTab, listByRole } = this.state;
        const row = listByRole[activeTab][index];
        if (row.id) {
            if (!window.confirm('Bạn có chắc chắn muốn xóa?')) return;
            this.setState({ deletingId: row.id });
            axios.post(global.config.apiDomain + '/bot/web/bot-live-room/delete', {
                id: row.id
            })
                .then(() => {
                    this.setState({ deletingId: null });
                    toast.success('Xóa thành công.');
                    this.loadRoleSettings(activeTab);
                })
                .catch(() => {
                    this.setState({ deletingId: null });
                    toast.error('Xóa thất bại.');
                });
        } else {
            const list = [...listByRole[activeTab]];
            list.splice(index, 1);
            this.setState({
                listByRole: { ...listByRole, [activeTab]: list }
            });
        }
    };

    handleDeactivateAllSaved = () => {
        const { activeTab, listByRole, bulkDeactivating } = this.state;
        if (bulkDeactivating) return;

        const savedRows = (listByRole[activeTab] || []).filter((row) => !!row.id);
        if (savedRows.length === 0) {
            toast.info('Không có record đã lưu để tắt hoạt động.');
            return;
        }

        this.setState({ bulkDeactivating: true });
        const requests = savedRows.map((row) => axios.post(
            global.config.apiDomain + '/bot/web/bot-live-room/update',
            {
                id: row.id,
                role: row.role,
                minUserOnline: Number(row.minUserOnline),
                maxUserOnline: Number(row.maxUserOnline),
                minBotOnline: Number(row.minBotOnline),
                maxBotOnline: Number(row.maxBotOnline),
                isActive: false,
            }
        ));

        Promise.allSettled(requests)
            .then((results) => {
                const failedCount = results.filter((r) => r.status === 'rejected').length;
                if (failedCount === 0) {
                    toast.success('Đã tắt hoạt động toàn bộ record đã lưu.');
                } else if (failedCount === savedRows.length) {
                    toast.error('Tắt hoạt động thất bại.');
                } else {
                    toast.warning(`Đã tắt hoạt động ${savedRows.length - failedCount}/${savedRows.length} record.`);
                }
                this.loadRoleSettings(activeTab);
            })
            .catch(() => {
                toast.error('Tắt hoạt động thất bại.');
            })
            .finally(() => {
                this.setState({ bulkDeactivating: false });
            });
    };

    handleActivateAllSaved = () => {
        const { activeTab, listByRole, bulkActivating } = this.state;
        if (bulkActivating) return;

        const savedRows = (listByRole[activeTab] || []).filter((row) => !!row.id);
        if (savedRows.length === 0) {
            toast.info('Không có record đã lưu để bật hoạt động.');
            return;
        }

        this.setState({ bulkActivating: true });
        const requests = savedRows.map((row) => axios.post(
            global.config.apiDomain + '/bot/web/bot-live-room/update',
            {
                id: row.id,
                role: row.role,
                minUserOnline: Number(row.minUserOnline),
                maxUserOnline: Number(row.maxUserOnline),
                minBotOnline: Number(row.minBotOnline),
                maxBotOnline: Number(row.maxBotOnline),
                isActive: true,
            }
        ));

        Promise.allSettled(requests)
            .then((results) => {
                const failedCount = results.filter((r) => r.status === 'rejected').length;
                if (failedCount === 0) {
                    toast.success('Đã bật hoạt động toàn bộ record đã lưu.');
                } else if (failedCount === savedRows.length) {
                    toast.error('Bật hoạt động thất bại.');
                } else {
                    toast.warning(`Đã bật hoạt động ${savedRows.length - failedCount}/${savedRows.length} record.`);
                }
                this.loadRoleSettings(activeTab);
            })
            .catch(() => {
                toast.error('Bật hoạt động thất bại.');
            })
            .finally(() => {
                this.setState({ bulkActivating: false });
            });
    };

    render() {
        const {
            activeTab,
            listByRole,
            loadingByRole,
            savingId,
            deletingId,
            bulkDeactivating,
            bulkActivating,
            validationErrors,
            conditionForm,
            creatingDefaultCondition,
            savingCondition,
            loadingCondition,
            conditionValidationErrors,
        } = this.state;
        const list = listByRole[activeTab] || [];
        const loading = loadingByRole[activeTab];

        const cardStyle = {
            border: '1px solid #e9ecef',
            borderRadius: '12px',
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
            overflow: 'hidden',
        };
        const tableWrapperStyle = {
            overflow: 'hidden',
            borderBottomLeftRadius: '12px',
            borderBottomRightRadius: '12px',
        };
        const inputStyle = {
            border: '1px solid #dee2e6',
            borderRadius: '6px',
            padding: '6px 10px',
            width: '100%',
            maxWidth: '80px',
        };

        return (
            <div id="content">
                <div className="container-fluid">
                    <h1 className="text-center mb-4" style={{ color: '#2c3e50', fontWeight: '600' }}>
                        Quản lý cài đặt BOT Phòng Trực Tuyến
                    </h1>

                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-8">
                            <div className="card mb-3" style={cardStyle}>
                                <div className="card-header bg-white border-bottom" style={{ padding: '16px 20px' }}>
                                    <h5 className="mb-0" style={{ color: '#495057', fontWeight: '600' }}>
                                        Điều kiện phòng trực tuyến
                                    </h5>
                                </div>
                                <div className="card-body">
                                    {loadingCondition && (
                                        <div className="text-muted small mb-2">
                                            Đang tải dữ liệu hiện tại...
                                        </div>
                                    )}
                                    <div className="form-row">
                                        <div className="form-group col-12 col-md-3">
                                            <label className="mb-1">Số lượng người dùng thật tối thiểu</label>
                                            <input
                                                type="number"
                                                min="0"
                                                className="form-control form-control-sm"
                                                value={conditionForm.minRealUsers}
                                                onChange={(e) => this.handleChangeConditionField('minRealUsers', e.target.value)}
                                                style={conditionValidationErrors.includes('minRealUsers') ? { border: '1px solid #dc3545' } : {}}
                                            />
                                        </div>
                                        <div className="form-group col-12 col-md-3">
                                            <label className="mb-1">Số lượng bài hát trong hàng đợi tối thiểu</label>
                                            <input
                                                type="number"
                                                min="0"
                                                className="form-control form-control-sm"
                                                value={conditionForm.minQueueSongs}
                                                onChange={(e) => this.handleChangeConditionField('minQueueSongs', e.target.value)}
                                                style={conditionValidationErrors.includes('minQueueSongs') ? { border: '1px solid #dc3545' } : {}}
                                            />
                                        </div>
                                        <div className="form-group col-12 col-md-3">
                                            <label className="mb-1">Số phút BOT vào phòng tối thiểu</label>
                                            <input
                                                type="number"
                                                min="0"
                                                className="form-control form-control-sm"
                                                value={conditionForm.minOnlineMinutes}
                                                onChange={(e) => this.handleChangeConditionField('minOnlineMinutes', e.target.value)}
                                                style={conditionValidationErrors.includes('minOnlineMinutes') ? { border: '1px solid #dc3545' } : {}}
                                            />
                                        </div>
                                        <div className="form-group col-12 col-md-3">
                                            <label className="mb-1">Số phút BOT vào phòng tối đa</label>
                                            <input
                                                type="number"
                                                min="0"
                                                className="form-control form-control-sm"
                                                value={conditionForm.maxOnlineMinutes}
                                                onChange={(e) => this.handleChangeConditionField('maxOnlineMinutes', e.target.value)}
                                                style={conditionValidationErrors.includes('maxOnlineMinutes') ? { border: '1px solid #dc3545' } : {}}
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm mr-2"
                                            disabled={creatingDefaultCondition}
                                            onClick={this.handleCreateDefaultCondition}
                                        >
                                            {creatingDefaultCondition ? (
                                                <span className="spinner-border spinner-border-sm" />
                                            ) : (
                                                'Tạo mặc định'
                                            )}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            disabled={savingCondition}
                                            onClick={this.handleUpdateCondition}
                                        >
                                            {savingCondition ? (
                                                <span className="spinner-border spinner-border-sm" />
                                            ) : (
                                                'Cập nhật điều kiện'
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <ul className="nav nav-tabs mb-3" role="tablist">
                                {TABS.map((tab) => (
                                    <li className="nav-item" key={tab.value}>
                                        <button
                                            type="button"
                                            className={`nav-link ${activeTab === tab.value ? 'active' : ''}`}
                                            onClick={() => this.setState({ activeTab: tab.value, validationErrors: {} })}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {tab.label}
                                        </button>
                                    </li>
                                ))}
                            </ul>

                            <div className="card" style={cardStyle}>
                                <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center" style={{ padding: '16px 20px' }}>
                                    <h5 className="mb-0" style={{ color: '#495057', fontWeight: '600' }}>
                                        Role: {activeTab}
                                    </h5>
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-info btn-sm mr-2"
                                            disabled={bulkActivating}
                                            onClick={this.handleActivateAllSaved}
                                        >
                                            {bulkActivating ? (
                                                <span className="spinner-border spinner-border-sm" />
                                            ) : (
                                                'Bật hoạt động'
                                            )}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-warning btn-sm mr-2"
                                            disabled={bulkDeactivating}
                                            onClick={this.handleDeactivateAllSaved}
                                        >
                                            {bulkDeactivating ? (
                                                <span className="spinner-border spinner-border-sm" />
                                            ) : (
                                                'Tắt hoạt động'
                                            )}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-success btn-sm"
                                            onClick={this.handleAddRow}
                                        >
                                            <i className="fas fa-plus mr-1"></i>
                                            Tạo
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body p-0" style={tableWrapperStyle}>
                                    {loading ? (
                                        <div className="text-center py-5">
                                            <div className="spinner-border text-primary" role="status" />
                                            <p className="mt-2 text-muted">Đang tải...</p>
                                        </div>
                                    ) : (
                                        <div className="table-responsive" style={{ margin: 0, borderRadius: '0 0 12px 12px' }}>
                                            <table
                                                className="table table-hover mb-0"
                                                style={{
                                                    borderCollapse: 'separate',
                                                    borderSpacing: 0,
                                                }}
                                            >
                                                <thead style={{ backgroundColor: '#f8f9fa' }}>
                                                    <tr>
                                                        <th className="align-middle" style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 600 }}>Số lượng người dùng tối thiểu</th>
                                                        <th className="align-middle" style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 600 }}>Số lượng người dùng tối đa</th>
                                                        <th className="align-middle" style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 600 }}>Số lượng BOT tối thiểu</th>
                                                        <th className="align-middle" style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 600 }}>Số lượng BOT tối đa</th>
                                                        <th className="align-middle" style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 600 }}>Bật/tắt hoạt động</th>
                                                        <th className="align-middle" style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 600, width: 240 }}>Thao tác</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {list.map((row, index) => (
                                                        <tr key={row.id || `new-${index}`} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#fafbfc' }}>
                                                            <td className="align-middle" style={{ padding: '10px 16px', borderBottom: '1px solid #eee' }}>
                                                                <input
                                                                    type="number"
                                                                    min="0"
                                                                    className="form-control form-control-sm"
                                                                    style={{
                                                                        ...inputStyle,
                                                                        ...(validationErrors?.[index]?.includes('minUserOnline') ? { border: '1px solid #dc3545' } : {}),
                                                                    }}
                                                                    value={row.minUserOnline}
                                                                    onChange={(e) => this.handleChangeRow(index, 'minUserOnline', e.target.value)}
                                                                />
                                                            </td>
                                                            <td className="align-middle" style={{ padding: '10px 16px', borderBottom: '1px solid #eee' }}>
                                                                <input
                                                                    type="number"
                                                                    min="0"
                                                                    className="form-control form-control-sm"
                                                                    style={{
                                                                        ...inputStyle,
                                                                        ...(validationErrors?.[index]?.includes('maxUserOnline') ? { border: '1px solid #dc3545' } : {}),
                                                                    }}
                                                                    value={row.maxUserOnline}
                                                                    onChange={(e) => this.handleChangeRow(index, 'maxUserOnline', e.target.value)}
                                                                />
                                                            </td>
                                                            <td className="align-middle" style={{ padding: '10px 16px', borderBottom: '1px solid #eee' }}>
                                                                <input
                                                                    type="number"
                                                                    min="0"
                                                                    className="form-control form-control-sm"
                                                                    style={{
                                                                        ...inputStyle,
                                                                        ...(validationErrors?.[index]?.includes('minBotOnline') ? { border: '1px solid #dc3545' } : {}),
                                                                    }}
                                                                    value={row.minBotOnline}
                                                                    onChange={(e) => this.handleChangeRow(index, 'minBotOnline', e.target.value)}
                                                                />
                                                            </td>
                                                            <td className="align-middle" style={{ padding: '10px 16px', borderBottom: '1px solid #eee' }}>
                                                                <input
                                                                    type="number"
                                                                    min="0"
                                                                    className="form-control form-control-sm"
                                                                    style={{
                                                                        ...inputStyle,
                                                                        ...(validationErrors?.[index]?.includes('maxBotOnline') ? { border: '1px solid #dc3545' } : {}),
                                                                    }}
                                                                    value={row.maxBotOnline}
                                                                    onChange={(e) => this.handleChangeRow(index, 'maxBotOnline', e.target.value)}
                                                                />
                                                            </td>
                                                            <td className="align-middle" style={{ padding: '10px 16px', borderBottom: '1px solid #eee' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={row.isActive}
                                                                    onChange={(e) => this.handleChangeRow(index, 'isActive', e.target.checked)}
                                                                />
                                                            </td>
                                                            <td className="align-middle" style={{ whiteSpace: 'nowrap', padding: '10px 16px', borderBottom: '1px solid #eee' }}>
                                                                {row.id ? (
                                                                    <>
                                                                        <button
                                                                            className="btn btn-primary btn-sm mr-1"
                                                                            disabled={savingId === row.id}
                                                                            onClick={() => this.handleUpdate(index)}
                                                                        >
                                                                            {savingId === row.id ? (
                                                                                <span className="spinner-border spinner-border-sm" />
                                                                            ) : (
                                                                                'Cập nhật'
                                                                            )}
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-danger btn-sm"
                                                                            disabled={deletingId === row.id}
                                                                            onClick={() => this.handleDelete(index)}
                                                                        >
                                                                            {deletingId === row.id ? (
                                                                                <span className="spinner-border spinner-border-sm" />
                                                                            ) : (
                                                                                'Xóa'
                                                                            )}
                                                                        </button>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <button
                                                                            className="btn btn-success btn-sm mr-1"
                                                                            disabled={savingId === `new-${index}`}
                                                                            onClick={() => this.handleSaveNew(index)}
                                                                        >
                                                                            {savingId === `new-${index}` ? (
                                                                                <span className="spinner-border spinner-border-sm" />
                                                                            ) : (
                                                                                'Lưu'
                                                                            )}
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-danger btn-sm"
                                                                            onClick={() => this.handleDelete(index)}
                                                                        >
                                                                            Xóa
                                                                        </button>
                                                                    </>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {list.length === 0 && (
                                                        <tr>
                                                            <td colSpan="6" className="text-center text-muted py-4" style={{ padding: '24px 16px', borderBottom: 'none' }}>
                                                                Chưa có cài đặt. Bấm <strong>Tạo</strong> để thêm mới.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
